module.exports = __webpack_public_path__ + "img/approved.790f43fb.svg";